var _defs, _polyline, _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew207({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "1.32 12.83 1.32 8.33 6.32 8.33 11.32 8.33 11.32 13.33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.32,
    y1: 3.33,
    x2: 6.32,
    y2: 8.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.56,5.73,8.1,7.12H7.51L9,2.7h.69l1.5,4.42H10.6l-.47-1.39ZM10,5.28,9.58,4c-.1-.29-.16-.55-.23-.81h0c-.07.26-.14.53-.23.8L8.68,5.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.49,7.12,11.05,2.7h.61l.69,2.17c.19.6.36,1.14.48,1.66h0c.12-.51.31-1.07.5-1.65l.75-2.18h.61L13.12,7.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew207);
export default __webpack_public_path__ + "static/media/Symbolpack_New_207.1d1a6ef1aacfb205033d4021794d51b6.svg";
export { ForwardRef as ReactComponent };